(function () {
  if (window.__csSave) return;
  window.__csSave = 1;

  function paint() {
    // subscribe is on unless the offer card has been switched off
    var sub = !document.querySelector('.cs-sub-card.off, .cs-flat.off');
    document.querySelectorAll('.cs-save').forEach(function (el) {
      var pct = parseInt(sub ? el.dataset.subPct : el.dataset.oncePct, 10);
      if (!pct || pct <= 0) { el.style.display = 'none'; return; }
      el.style.display = '';
      el.textContent = 'Save ' + pct + '%';
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.cs-tile, .js-cs-swap')) setTimeout(paint, 30);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else setTimeout(paint, 60);
  document.addEventListener('shopify:section:load', function () { setTimeout(paint, 60); });
})();
